const PRICE_DISCOUNT_CONFIG = {
    priceSeparatorSymbol: '&#8250;',
    cssDiscountPercentagePosition: 'odf-ribbon-top-right',
    cssDiscountPercentageTheme: 'odf-ribbon-discount',
    discountPercentagePrefix: '&#45;',
    discountPercentageSuffix: '&#37;',
};
const INVALID_HOTEL_DATA = ['UNKNOWN', 'UN', 'RO'];
const VALIDATE_ROOMS_LEFT = Odigeo._.range(1, 5);
const PRICE_SIZE_CLASS = [
    Odigeo._.partial(getShortPriceSize, ['od-rwd-lg', 'od-rwd-md']),
    Odigeo._.partial(getMediumPriceSize, ['od-rwd-2lg', 'od-rwd-lg']),
    Odigeo._.partial(getLongPriceSize, ['od-rwd-xl', 'od-rwd-2lg']),
    Odigeo._.constant(['odf-text-2xl', 'odf-text-2lg']),
];
const HTML_HOTEL_TEMPLATES = {
    NONE: '',
    PRICE: 'price',
    DISCOUNT: 'priceDiscount',
    PRIME: 'pricePrime',
};
const DISCOUNT_LEVEL_1 = 25;
const DISCOUNT_LEVEL_2 = 15;

const TOP_DESTINATIONS = ['ALC', 'AMS', 'AYT', 'AHN', 'ATH', 'BLA', 'BCN', 'BER', 'BJV', 'BUD', 'CUN', 'CTA', 'CPH', 'CFU',
    'DXB', 'DBV', 'FAO', 'FUE', 'FNC', 'LPA', 'HER', 'IBZ', 'IST', 'ACE', 'LAS', 'LIS', 'LON', 'LOZ', 'YXU',
    'MAD', 'AGP', 'MLA', 'MIL', 'MAH', 'JMK', 'NCE', 'PMO', 'PMI', 'PAR', 'PHT', 'OPO', 'PRG', 'RHO', 'ROM',
    'RMG', 'JTR', 'SVQ', 'STO', 'TCI', 'VLC', 'VCE', 'VIE'];

const SUMMER_SEARCH_RANGE = ['06-15', '08-31'];
const SUMMER_ARRIVAL_RANGE = ['07-01', '09-15'];
const CHRISTMAS_SEARCH_RANGE = ['11-15', '11-31'];
const CHRISTMAS_ARRIVAL_RANGE = ['12-01', '01-07'];
const LAST_MINUTE_DAYS = 30;

const {
    checkMinimumDiscount,
    checkMinimumDiscountStrikethroughPrice,
} = require('od-modules/helpers/price/dynpack_price_discounts');

function getShortPriceSize(classSize, sizePrice, hasMinimumDiscount) {
    return sizePrice > 16 && hasMinimumDiscount ? classSize : null;
}

function getMediumPriceSize(classSize, sizePrice, hasMinimumDiscount) {
    return (sizePrice > 10 && hasMinimumDiscount) || sizePrice > 18 ? classSize : null;
}

function getLongPriceSize(classSize, sizePrice, hasMinimumDiscount) {
    return hasMinimumDiscount && sizePrice > 8 ? classSize : null;
}

function isValidHotelData(hotelData) {
    return !Odigeo._.isEmpty(hotelData) && !Odigeo._.includes(INVALID_HOTEL_DATA, hotelData);
}

function hasHotelRoomsLeft(roomsLeft) {
    return !Odigeo._.isNull(roomsLeft) && Odigeo._.includes(VALIDATE_ROOMS_LEFT, roomsLeft);
}

function getRoomsLeftData({roomsLeft}) {
    const hasRoomLeftUrgent = roomsLeft === 1;
    const {roomleftLast, roomleftAvailable} = Odigeo.UIElements.translations.dynpackProduct.roomSelection;
    const translation = hasRoomLeftUrgent ? roomleftLast : roomleftAvailable;

    return {
        hasRoomsLeft: !Odigeo._.isNull(roomsLeft) && roomsLeft >= 1 && roomsLeft <= 4,
        roomsLeftTranslation: Odigeo.Utils.replaceCmsKeyArgs(translation, roomsLeft),
        hasRoomLeftUrgent,
        roomsLeft,
    };
}

function getSizePrice(price) {
    const currencySign = Odigeo.Utils.Currency.currencySign;
    const hasUnescapedSymbol = currencySign !== Odigeo.Utils.Currency.currencyCode && Odigeo._.size(currencySign) > 1;
    const oneSpace = ' ';

    return hasUnescapedSymbol ?
        Odigeo._.size(price.replace(currencySign, oneSpace)) :
        Odigeo._.size(price);
}

function getPriceSizeCssModifier(price, hasDiscount) {
    return Odigeo._.zipObject(['primary', 'secondary'], Odigeo._.spread(Odigeo._.find(PRICE_SIZE_CLASS, function(getClass) {
        return !Odigeo._.isNull(getClass(price, hasDiscount));
    }))(arguments));
}

function getPriceColorCssModifier(roomsLeft) {
    return hasHotelRoomsLeft(roomsLeft) ? 'odf-text-negative' : '';
}

function getHotelCategory(category) {
    return Odigeo._.isString(category) ? Odigeo.Utils.parseJson(category) : category;
}

function getPriceFormat(price) {
    return Odigeo._.pick(Odigeo.Utils.splitFormatedCurrency(Math.abs(price)), Odigeo._.negate(Odigeo._.isNull));
}

function getPriceDiscountData(data) {
    const differentialPricePerPassenger = Odigeo._.get(data, 'differentialPricePerPassenger', 0);
    const hasMinimumDiscount = checkMinimumDiscount(data);
    const hasMinimumDiscountStrikethrough = checkMinimumDiscountStrikethroughPrice(data);
    const priceFormat = getSizePrice(Odigeo.Utils.formatCurrency(data.price));
    const priceSizeCssModifier = getPriceSizeCssModifier(priceFormat, hasMinimumDiscount);
    const fareDiscountPrice = data.pricePerPassengerWithoutDiscount;
    const providerPrice = data.price;

    return Odigeo._.extend({}, PRICE_DISCOUNT_CONFIG, {
        fareDiscountPrice,
        providerPrice,
        fareDiscountPercentage: data.discountPercentage,
        hasMinimumDiscount,
        hasMinimumDiscountStrikethrough,
        primaryPriceSizeCssModifier: priceSizeCssModifier.primary,
        secondaryPriceSizeCssModifier: priceSizeCssModifier.secondary,
        hasInfoDiscount: data.hasInfoDiscount,
        formatDiscount: getPriceFormat(fareDiscountPrice - providerPrice),
        formatPrice: getPriceFormat(data.price),
        formatDifferentialPrice: getPriceFormat(differentialPricePerPassenger),
        differentialPricePrefix: differentialPricePerPassenger < 0 ? '-' : '+',
        formatFareDiscountPrice: getPriceFormat(data.pricePerPassengerWithoutDiscount),
        priceDiscountTitleCms: !data.hasInfoDiscount ? '' : Odigeo.Utils.replaceCmsKeyArgs(
            Odigeo.UIElements.translations.dynpackProduct.pricediscount.titleCms,
            PRICE_DISCOUNT_CONFIG.discountPercentagePrefix
                .concat(Math.floor(data.discountPercentage).toString())
                .concat(PRICE_DISCOUNT_CONFIG.discountPercentageSuffix)),
    });
}

function getMembershipDiscountClass(isFlightWithoutDiscount) {
    return isFlightWithoutDiscount ? 'od-pricebreakdown-membership-discount-fee-warning' : 'od-pricebreakdown-membership-discount-fee';
}

function getMembershipPriceDiscountClass(membershipDiscountClass, isFlightWithoutDiscount) {
    return isFlightWithoutDiscount ? membershipDiscountClass + ' odf-text-line-through' : membershipDiscountClass;
}

function getDisclaimer(model, disclaimers) {
    const defaultDisclaimer = model.isBestPrice ? disclaimers.BEST_PRICE : disclaimers.PRICE_BREAK_DOWN_FEE;

    return model.isFullprice && !Odigeo._.isEmpty(model.listRoomDeals) ? disclaimers.ROOM_SELECTION_FEE : defaultDisclaimer;
}

function extendPriceBreakdownData(model, priceBreakdown) {
    return Odigeo._.extend({}, priceBreakdown, {
        isBestPrice: model.isBestPrice,
        isFullPrice: model.isFullPrice,
        numberOfSegments: model.numberOfSegments,
        fullTablePriceBreakDownOnFullPrice: Odigeo._.get(model, 'priceDisplayConfig.fullTablePriceBreakDownOnFullPrice', false),
        showPricePerPax: Odigeo._.get(model, 'priceDisplayConfig.showPricePerPax', false),
        numPassengers: model.numPassengers,
        formatCurrency: Odigeo._.partial(Odigeo.Utils.formatCurrency, _, Odigeo._.extend({}, Odigeo.Utils.Currency, {negationSymbol: '- '})),
        disclaimer: getDisclaimer(model, priceBreakdown.disclaimers),
        dynpackFareDiscountDetails: model.dynpackFareDiscountDetails,
    });
}

function extendPriceBreakdownPrimeData(model, priceBreakdown) {
    const isFlightWithoutDiscount = Odigeo._.get(model.flightSelectionDTO, 'fareItinerary.priceWithoutDiscountSelected', false);
    const membershipDiscountClass = getMembershipDiscountClass(isFlightWithoutDiscount);

    return Odigeo._.extend(extendPriceBreakdownData(model, priceBreakdown), {
        isMembershipPriceDisplay: Odigeo._.get(priceBreakdown, 'membershipPerksDTO.memberLoggedIn', false),
        isMembershipPriceOrDualPriceDisplay: Odigeo._.get(priceBreakdown, 'membershipPerksDTO.includedInPrice', false),
        membershipDiscountClass: membershipDiscountClass,
        membershipPriceDiscountClass: getMembershipPriceDiscountClass(membershipDiscountClass, isFlightWithoutDiscount),
        isFlightWithoutDiscount: isFlightWithoutDiscount,
    });
}

function getOnLoadError(thumb) {
    return `this.onerror=null;this.src='${thumb}'`;
}

function getBackgroundImageError(urlImage, urlOnError) {
    return `background-image: url('${urlImage}'), url('${urlOnError}')`;
}

function getBoardTypeIcon(boardType) {
    const iconBoardTypeDictionary = {
        HB: 'odf-icon-food-meal',
        AI: 'odf-icon-wine-food',
        BB: 'odf-icon-coffee-cup',
        FB: 'odf-icon-fork-knife',
        SC: 'odf-icon-microwave',
    };

    return iconBoardTypeDictionary[boardType] || '';
}

function isTopChoice(hotelData) {
    return Odigeo._.get(hotelData, 'accommodationDeal.providerId') === 'OC';
}

function getTrackingLabelLoadedResults(accommodationResults) {
    const numResults = accommodationResults.length;
    const groupedProviders = countProviders(accommodationResults);

    return [
        `list_shown:${numResults}_bc:${groupedProviders.BC ? groupedProviders.BC : 0}`,
        `_hb:${groupedProviders.HB ? groupedProviders.HB : 0}`,
        `_oc:${groupedProviders.OC ? groupedProviders.OC : 0}`,
        `_hc:${groupedProviders.HC ? groupedProviders.HC : 0}`].join('');
}

function getTrackingDataProvidedOlsetScore(accommodationResults) {
    const isProvided = Odigeo._.get(accommodationResults, '[0]accommodationDeal.score', null) !== null ? 1 : 0;
    const category = 'dynpack_hotel_results';

    const action = 'olset_score';
    const label = `olset_provided_${isProvided}`;

    return [category, action, label];
}

function countProviders(accommodationResults) {
    return Odigeo._.chain(accommodationResults).countBy('accommodationDeal.providerId').value();
}

function getFlightItemResult(result, data) {
    const totalPrice = Odigeo.AB.isDynpackPrimePrices
        ? result.priceBreakdownDynpack.sortPrice * result.numPassengers : result.priceBreakdownDynpack.totalPrice;

    return {
        templates: Odigeo.Utils.getTemplates($('#dpresults-templates'), {
            priceDiscount: '.differential-price-template',
            pricePrime: '.price-prime-template',
        }),
        currencyDiffers: result.dynpackCurrencyDiffers,
        tripAdvisorReview: {},
        selectedClass: `book_btn od-dynpack-book-btn ${getBookButtonClass(result.flightPreselectedId === result.mainItineraryId)}`,
        bookButtonText: Odigeo.AB.isDynpackDesktopMultiTab ?
            Odigeo.UIElements.translations.dynpackProduct.flightResults.multitabButton :
            Odigeo.Utils.pluralizeAll(data.translations.selectFlight, result.numberOfSegments),
        hookButtonClass: 'resultpage_button_box',
        nightsText: Odigeo.UIElements.translations.dynpackProduct.pricediscount.perPassenger,
        totalPriceText: Odigeo.UIElements.translations.dynpackProduct.pricediscount.totalPrice,
        totalPriceDisplay: Odigeo.Utils.formatCurrency(totalPrice),
        priceDiscountDynpack: getPriceDiscountData({
            pricePerPassengerWithoutDiscount: Odigeo._.get(result, 'dynpackPriceDiscount.pricePerPassengerWithoutDiscount'),
            discountPercentage: Odigeo._.get(result, 'dynpackPriceDiscount.discountPercentage'),
            price: Odigeo._.get(result, 'dynpackPriceDiscount.priceByProduct'),
            differentialPricePerPassenger: Odigeo._.get(result, 'differentialPricePerPassenger'),
            dynpackFare: Odigeo._.get(result, 'dynpackPriceDiscount.accommodationDeal.dynpackFare'),
            hasInfoDiscount: true,
        }),
        freeRebookingText: Odigeo.UIElements.translations.dynpackProduct.flightResults.freeRebooking,
    };
}

function getPassengerTranslations(data, keys) {
    return Odigeo._.reduce(keys, function(memo, passengerText, passengerKey) {
        const nPassenger = data[passengerKey];

        if (Odigeo._.isNumber(nPassenger) && nPassenger !== 0) {
            memo.push(Odigeo.Utils.pluralizeAll(passengerText, nPassenger));
        }

        return memo;
    }, []).join(', ');
}

function getPriceTemplate(data, noPrice) {
    if (noPrice) {
        return HTML_HOTEL_TEMPLATES.NONE;
    } else if (data.primePriceBreakdown) {
        return HTML_HOTEL_TEMPLATES.PRIME;
    } else if (data.hasMinimumDiscount) {
        return HTML_HOTEL_TEMPLATES.DISCOUNT;
    } else {
        return HTML_HOTEL_TEMPLATES.PRICE;
    }
}

function getSelectorByData(data) {
    return `[data-${data.detail}="${data.value}"]:not(${data.exclude})`;
}

function calculateListPosition(indexHotelList) {
    const hotelsPerPage = Odigeo.Utils.parseJson(Odigeo.Session.get('fromTo')).from;
    return indexHotelList + hotelsPerPage + 1;
}

function buildLabel({action, key, position, price, providerCurrency, type, providerId, chain}) {
    return [
        `${action}:${key}`,
        `pos:${position}`,
        `prc:${price}-${providerCurrency.toLowerCase()}`,
        `type:${Odigeo.Utils.extractNumberOfChar(type, 4)}`,
        `sup:${providerId}`.toLowerCase(),
        `cha:${Odigeo.Utils.extractNumberOfChar(chain, 4)}`,
        `list:`].join('_');
}

function buildHotelSelectOrClickLabel(accommodation, action, sorting) {
    const accommodationDeal = Odigeo._.get(accommodation, 'accommodationDeal', {});
    const accommodationInfo = Odigeo._.get(accommodation, 'accommodationInfo', {});

    const dataForLabel = {
        action,
        key: accommodationDeal.key,
        position: 'NA',
        price: Odigeo._.get(accommodation, 'price', 0),
        providerCurrency: Odigeo._.get(accommodationDeal, 'providerCurrency', ''),
        type: Odigeo._.get(accommodationInfo, 'type', ''),
        providerId: Odigeo._.get(accommodationDeal, 'providerId', ''),
        chain: Odigeo._.get(accommodationInfo, 'chain', 'nan') || 'nan',
    };
    return `${buildLabel(dataForLabel)}${sorting}`;
}

function buildHotelSelectedLabel(accommodation, indexHotelList, sorting) {
    const accommodationDeal = Odigeo._.get(accommodation, 'accommodationDeal', {});
    const accommodationInfo = Odigeo._.get(accommodation, 'accommodationInfo', {});
    const priceBreakdownDynpack = Odigeo._.get(accommodation, 'priceBreakdownDynpack', {});

    return [
        `hotel_selected:${Odigeo._.get(accommodationDeal, 'key', '')}`,
        `_pos:${indexHotelList}`,
        `_prc:${Odigeo._.get(priceBreakdownDynpack, 'pricePerPassenger', Odigeo._.get(accommodation, 'price', 0))}`,
        `-${_(priceBreakdownDynpack).get('providerCurrency', Odigeo._.get(accommodationDeal, 'providerCurrency', '')).toLowerCase()}`,
        `_type:${Odigeo.Utils.extractNumberOfChar(Odigeo._.get(accommodationInfo, 'type', ''), 4)}`,
        `_sup:${Odigeo._.get(accommodationDeal, 'providerId', '').toLowerCase()}`,
        `_cha:${Odigeo.Utils.extractNumberOfChar(Odigeo._.get(accommodationInfo, 'chain', 'nan') || 'nan', 4)}`,
        `_list:${sorting}`].join('');
}

function getBookButtonClass(isSelected) {
    return isSelected ? 'selected odf-btn-primary' : 'odf-btn-secondary';
}

function getTripAdvisorRateMessage(userRate, keysText) {
    userRate = parseFloat(userRate) || 0;
    const rateKey = Math.min(4, Math.floor(2 * userRate - 5));
    const rateText = keysText[`userRate${rateKey}`];

    return rateText ? rateText : '';
}

function getReviewsProvider(accommodationSearchReviews) {
    const reviewsData = getReviewsData(accommodationSearchReviews);
    return reviewsData && reviewsData.source || 'TA';
}

function getReviewsData(accommodationSearchReviews) {
    if (Odigeo.AB.isDynpackTrustYouReviews) {
        let reviewsProvider = Odigeo._.find(accommodationSearchReviews, (review) => Odigeo._.isEqual(review.source, 'TY'));
        if (reviewsProvider) {
            return reviewsProvider;
        }
    }
    return Odigeo._.find(accommodationSearchReviews, (review) => Odigeo._.isEqual(review.source, 'TA'));
}

function getDifferentHotelStay(formatMask) {
    const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
    const departureDate = Odigeo._.get(searchParameters, 'searchSegments[0].dateStr');
    const arrivalDate = Odigeo._.get(searchParameters, 'searchSegments[1].dateStr');
    const checkInDate = Odigeo._.get(searchParameters, 'checkInDate');
    const checkOutDate = Odigeo._.get(searchParameters, 'checkOutDate');
    const hasDifferentHotelStay = checkInDate && checkOutDate && (departureDate !== checkInDate || arrivalDate !== checkOutDate);

    return {
        checkInDateFormat: hasDifferentHotelStay ? Odigeo.Utils.formatDate(new Date(checkInDate), formatMask, true) : '',
        checkOutDateFormat: hasDifferentHotelStay ? Odigeo.Utils.formatDate(new Date(checkOutDate), formatMask, true) : '',
    };
}

function getTextPriceTotal(people, nights, isPrime = false) {
    const isAccommodtionPostBooking = Odigeo.Utils.parseJson(Odigeo.Session.get('isAccommodationPostBooking'));

    if (isAccommodtionPostBooking) {
        const translations = Odigeo.UIElements.translations.accommodationPostBooking.postBookingTotalPrice;
        return Odigeo.Utils.pluralizeAll(translations, people, nights);
    } else {
        const {perPassenger, priceWithPrime} = Odigeo.UIElements.translations.dynpackProduct.pricediscount;
        return isPrime ? `${perPassenger} ${priceWithPrime}` : perPassenger;
    }
}

function getPaxQuantity(detailPassengers) {
    const sumBy = (arr, func) => arr.reduce((acc, item) => acc + func(item), 0);
    const hasPaxQuantity = detailPassengers && Array.isArray(detailPassengers);
    return hasPaxQuantity ? sumBy(detailPassengers, (o) => o.quantity) : 1;
}

function getPrimePriceData(priceBreakdownDynpack) {
    const primePriceData = Odigeo.Utils.splitFormatedCurrency(priceBreakdownDynpack.sortPrice) || 0;
    const membershipPerkFee = priceBreakdownDynpack.membershipPerksDTO && priceBreakdownDynpack.membershipPerksDTO.fee || 0;
    const pax = getPaxQuantity(priceBreakdownDynpack.detailPassengers);
    const membershipPerkFeePerPerson = membershipPerkFee / pax;
    const slashedPrimePriceData = priceBreakdownDynpack.sortPrice - membershipPerkFeePerPerson;
    const slashedPrimePriceDataBreakDown = Odigeo.Utils.splitFormatedCurrency(slashedPrimePriceData);
    const dpDiscountPerPerson = priceBreakdownDynpack.dynpackFareDiscount ? priceBreakdownDynpack.dynpackFareDiscount / pax : 0;
    const noPrimePriceWithDiscountDataBreakDown = dpDiscountPerPerson ?
        Odigeo.Utils.splitFormatedCurrency(slashedPrimePriceData + dpDiscountPerPerson) : null;
    const pricePrimeSlashedDataBreakDown = noPrimePriceWithDiscountDataBreakDown ?
        noPrimePriceWithDiscountDataBreakDown : slashedPrimePriceDataBreakDown;

    return {
        pricePrimeSlashedDataBreakDown,
        noPrimePriceWithDiscountDataBreakDown,
        primePriceBreakdown: primePriceData,
        slashedPrimePriceData,
        slashedPrimePriceDataBreakDown,
        bookButtonId: 'dp-accommodation-results-hotel-card-prime-book-btn',
    };
}

function getCurrency(value) {
    return value === null ? '' : value;
}

function getPrimePriceBreakdownData(data) {
    const separator = data.pricePrimeSlashedDataBreakDown.decimal[0];
    const {prefix, sufix} = data.pricePrimeSlashedDataBreakDown;
    const hasPackageDiscount = data.pricePrimeSlashedDataBreakDown !== data.slashedPrimePriceDataBreakDown;
    const primeDiscountValue = hasPackageDiscount
        ? data.slashedPrimePriceDataBreakDown.quantity - data.primePriceBreakdown.quantity
        : data.pricePrimeSlashedDataBreakDown.quantity - data.primePriceBreakdown.quantity;
    const packageDiscountValue = hasPackageDiscount
        ? data.pricePrimeSlashedDataBreakDown.quantity - data.slashedPrimePriceDataBreakDown.quantity
        : 0;

    return {
        priceBreakdownData: {
            primeDiscount: {
                value: `${getCurrency(prefix)}${
                    separator
                        ? primeDiscountValue.toFixed(2).replace('.', separator)
                        : getPriceFormat(Math.floor(primeDiscountValue)).integer
                }${getCurrency(sufix)}`,
                shouldDisplay: primeDiscountValue > 0,
            },
            packageDiscount: {
                value: `${getCurrency(prefix)}${
                    separator
                        ? packageDiscountValue.toFixed(2).replace('.', separator)
                        : getPriceFormat(Math.floor(packageDiscountValue)).integer
                }${getCurrency(sufix)}`,
                shouldDisplay: packageDiscountValue > 0,
            },
            hasMinimumDiscount: primeDiscountValue > 0 || packageDiscountValue > 0,
        },
    };
}

function getDiscountLevel(discount, labels) {
    const {discountLevel1, discountLevel2, discountLevel3} = labels;
    let label;

    if (discount >= DISCOUNT_LEVEL_1) {
        label = discountLevel1;
    } else if (discount >= DISCOUNT_LEVEL_2) {
        label = discountLevel2;
    } else {
        label = discountLevel3;
    }
    return label;
}

function getDiscountLabel(discount, keys) {
    if (Odigeo.AB.isPricePerceptionRevamp || Odigeo.AB.isDpPricePerceptionRevamp) {
        const label = getDiscountLevel(discount, keys);
        return Odigeo.Utils.replaceCmsKeyArgs(label, discount);
    } else {
        return `-${discount}%`;
    }
}

function getNonPrimePriceBreakdown(data) {
    const separator = data.priceDiscountDynpack ? data.priceDiscountDynpack.formatPrice.decimal[0] : data.priceBreakdown.decimal[0];
    const {prefix, sufix} = data.priceBreakdown ? data.priceBreakdown : data.priceDiscountDynpack.formatPrice;
    const {amountDiscountedPerPassenger} = data.dynpackFareDiscountDetails;
    const packageDiscountValue = amountDiscountedPerPassenger.decimal
        ? amountDiscountedPerPassenger.toFixed(2).replace('.', separator)
        : Math.floor(amountDiscountedPerPassenger);

    return {
        priceBreakdownData: {
            packageDiscount: {
                value: `${getCurrency(prefix)}${packageDiscountValue}${getCurrency(sufix)}`,
                shouldDisplay: packageDiscountValue > 0,
            },
        },
    };
}

function getPriceBreakdownData(data) {
    return Odigeo.AB.isDynpackPrimeEnable ? getPrimePriceBreakdownData(data) : getNonPrimePriceBreakdown(data);
}

function getScarcityWidgetData() {
    return {
        topDestinations: TOP_DESTINATIONS,
        summerSearchRange: SUMMER_SEARCH_RANGE,
        summerArrivalRange: SUMMER_ARRIVAL_RANGE,
        christmasSearchRange: CHRISTMAS_SEARCH_RANGE,
        christmasArrivalRange: CHRISTMAS_ARRIVAL_RANGE,
        lastMinuteDays: LAST_MINUTE_DAYS,
    };
}

module.exports = {
    getBookButtonClass,
    extendPriceBreakdownData,
    extendPriceBreakdownPrimeData,
    getFlightItemResult,
    getBackgroundImageError,
    getBoardTypeIcon,
    getHotelCategory,
    getOnLoadError,
    getPassengerTranslations,
    getPriceColorCssModifier,
    getPriceDiscountData,
    getPriceFormat,
    getRoomsLeftData,
    getTrackingDataProvidedOlsetScore,
    getTrackingLabelLoadedResults,
    hasHotelRoomsLeft,
    isTopChoice,
    isValidHotelData,
    getPriceTemplate,
    getSelectorByData,
    buildHotelSelectOrClickLabel,
    buildHotelSelectedLabel,
    getTripAdvisorRateMessage,
    getReviewsProvider,
    getReviewsData,
    getDifferentHotelStay,
    getSizePrice,
    getPriceSizeCssModifier,
    getTextPriceTotal,
    calculateListPosition,
    buildLabel,
    getPrimePriceData,
    getPriceBreakdownData,
    getDiscountLabel,
    getDiscountLevel,
    getScarcityWidgetData,
};
